import { makeAuthService } from '../../auth/auth-service-factory';
import { makeLogService } from '../../common/log/log/log-service-factory';
import { ResolutionServiceImpl } from './resolution-service-impl';

export function makeResolutionService() {
  return new ResolutionServiceImpl(makeLogService(), makeAuthService());
}
